import { Tag, TagCreate } from "../../model/tag/Tag";
import { api } from "../api";
import { parseTag } from "../../parsers/tags/parseTag";

export const postTag = async (categoryId: string, data: TagCreate): Promise<Tag> => {
  const response = await api.services.tag.createTag({ categoryId, value: data.value });
  return parseTag(response.data);
};
